import axios from "axios";
import constant from "../../constant";

export const getListing = (
  page,
  search,
  price,
  sort,
  sortby,
  amenities,
  attendees,
  cur_value,
  purpose,
  map
) => {
  return (dispatch, getState) => {
    // make async call to database
    if (map || page <= 1) {
      dispatch({ type: "GET_LISTING_BEGIN" });
    } else {
      dispatch({ type: "GET_LISTING_LOADING" });
    }

    axios
      .get(`${constant.phpHost}action/newspace.php`, {
        params: {
          todo: "get_spaces",
          search: search,
          page: page,
          price: price,
          sort: sort,
          sortby: sortby,
          amenities: amenities,
          attendees: attendees,
          cur_value: cur_value,
          purpose: purpose
        }
      })
      .then(res => {
        let listing = res.data;
        map || page <= 1
          ? dispatch({ type: "GET_LISTING_MAP", listing })
          : dispatch({ type: "GET_LISTING", listing });
      });
  };
};
